import { DateRange } from "react-day-picker"
import {
  addDays,
  differenceInYears,
  format,
  getHours,
  getMinutes,
  isMatch,
  isToday,
  isTomorrow,
  isValid,
  isYesterday,
  parse,
  parseISO,
} from "date-fns"

const MILLISECONDS_IN_SECOND = 1000
const MILLISECONDS_IN_MINUTE = 1000 * 60
const MILLISECONDS_IN_HOUR = 1000 * 60 * 60
const MILLISECONDS_IN_DAY = 1000 * 60 * 60 * 24
const MINUTES_IN_DAY = 24 * 60
export const HYPHEN_CHARACTER = "-"
export const DOT_CHARACTER = "."
export const DD_MM_YYYY = "dd.MM.yyyy"

export const DATE_FORMATS = {
  ISODateFormat: "yyyy-MM-dd",
}

export { MILLISECONDS_IN_SECOND, MILLISECONDS_IN_MINUTE, MILLISECONDS_IN_HOUR, MILLISECONDS_IN_DAY, MINUTES_IN_DAY }

export const formatDate = (date: Date | number | undefined | null, dateFormat = DD_MM_YYYY) => {
  if (date && isValid(date)) {
    return format(date, dateFormat)
  } else return ""
}

export const formatDateRange = (date: DateRange | undefined | null, dateFormat = DD_MM_YYYY) => {
  if (date) {
    return (
      (date.from ? format(date.from, dateFormat) : "") +
      ` ${HYPHEN_CHARACTER} ` +
      (date.to ? format(date.to, dateFormat) : "")
    )
  } else return ""
}

export const formatDateForAppointment = (
  date: string,
  translations: {
    todayText: string
    yesterdayText: string
    tomorrowText: string
  },
) => {
  const dateObj = new Date(date)

  if (isToday(dateObj)) {
    return translations.todayText
  }
  if (isYesterday(dateObj)) {
    return translations.yesterdayText
  }
  if (isTomorrow(dateObj)) {
    return translations.tomorrowText
  }
  return formatDate(dateObj)
}

export const getMinutesFromDate = (date: Date) => {
  const hours = getHours(date)
  const minutes = getMinutes(date)
  return hours * 60 + minutes
}

export const getAgeFromBirthdate = (date: string) => {
  return differenceInYears(new Date(), date)
}

export const formatDateString = (date: string | undefined, dateFormat = "dd.MM.yyyy HH:mm") => {
  if (date) {
    return format(parseISO(date), dateFormat)
  } else return ""
}

export const formatDateRangeInput = (range: DateRange | undefined, dateFormat = DD_MM_YYYY) => {
  if (!range) return ""

  return (
    (range.from ? format(range.from, dateFormat) : "") +
    ` ${HYPHEN_CHARACTER} ` +
    (range.to ? format(range.to, dateFormat) : "")
  )
}

export const parseDateFromString = (dateString: string, format = DD_MM_YYYY) => {
  return parse(dateString, format, new Date())
}

export const formatDateRangeWithDot = (value: string, isFormatWithDot?: boolean) => {
  if (!value) return ""

  let input = value.replace(/[^0-9.-]/g, "")
  if (!isFormatWithDot) return input

  const { length } = input
  if ((length === 2 || length === 5 || length === 13 || length === 16) && !input.endsWith(DOT_CHARACTER)) {
    input += DOT_CHARACTER
  }
  if (input.length === 10 && !input.endsWith(HYPHEN_CHARACTER)) {
    input += HYPHEN_CHARACTER
  }

  return input
}

export const isMatchFormat = (date: string, format = DD_MM_YYYY) => {
  if (date?.length === format.length && isMatch(date, format)) return true
  return false
}

export const getDatesFromRange = (range: string, format = DD_MM_YYYY) => {
  const dates = range.split(HYPHEN_CHARACTER)
  const fromDateString = isMatchFormat(dates[0]?.trim(), format) ? dates[0]?.trim() : ""
  const toDateString = isMatchFormat(dates[1]?.trim(), format) ? dates[1]?.trim() : ""
  const fromDate = parseDateFromString(fromDateString)
  const toDate = parseDateFromString(toDateString)
  return { fromDate, toDate }
}

export const addDaysToDate = (date: Date, days: number) => addDays(date, days)
